const STORAGE_KEY = 'cookie_consent';

export interface CookiePreferences {
  essential: true; // always on
  analytics: boolean;
  errorTracking: boolean;
}

const DEFAULTS: CookiePreferences = {
  essential: true,
  analytics: false,
  errorTracking: false,
};

export function getCookiePreferences(): CookiePreferences | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CookiePreferences;
  } catch {
    return null;
  }
}

export function setCookiePreferences(prefs: CookiePreferences): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  // Dispatch event so other parts of the app can react
  window.dispatchEvent(new CustomEvent('cookie-consent-change', { detail: prefs }));
}

export function hasConsented(): boolean {
  return getCookiePreferences() !== null;
}

export function acceptAll(): void {
  setCookiePreferences({ essential: true, analytics: true, errorTracking: true });
}

export function acceptEssentialOnly(): void {
  setCookiePreferences({ ...DEFAULTS });
}

export function isAnalyticsAllowed(): boolean {
  return getCookiePreferences()?.analytics ?? false;
}

export function isErrorTrackingAllowed(): boolean {
  return getCookiePreferences()?.errorTracking ?? false;
}

/** Remove GA cookies when consent is revoked */
export function clearAnalyticsCookies(): void {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const name = cookie.split('=')[0].trim();
    if (name.startsWith('_ga')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }
}
